import { PageMeta } from "@/components/shared/PageMeta"
import CatalogCard from "@/components/shared/CatalogCard"
import BuyNowButton from "@/features/checkout/BuyNowButton"
import SERVICES, { getServiceIdBySlug, type ServiceProps } from "@/content/services"
import { SERVICE_SLUGS } from "@/content/slugs"
import { getDisplayPrice, promotionFromActive } from "@/content/prices"
import { PAGE_SEO } from "@/lib/seo"
import { useActivePromotionForItem } from "@/features/promotions/ActivePromotionProvider"

interface ServiceCardProps {
	slug: string
	service: ServiceProps
}

function ServiceCard({ slug, service }: ServiceCardProps): React.JSX.Element {
	const active = useActivePromotionForItem(service.id)
	const promo = promotionFromActive(active)
	const price = getDisplayPrice(service.price, promo, service.id)
	const hasFreeShipping = Boolean(active?.freeShipping && active.itemIds.includes(service.id))
	const cartItem = { id: service.id, priceId: service.priceId, amount: 1 }

	return (
		<CatalogCard
			href={`/servicios/${slug}`}
			imageSrc={service.image.source}
			eager
			title={service.name}
			subtitle={service.set}
			price={price}
			hasFreeShipping={hasFreeShipping}
			buyButton={
				<BuyNowButton
					cartItem={cartItem}
					text="Comprar"
					variant="default"
					size="sm"
					className="ml-auto shrink-0 cursor-pointer"
				/>
			}
		/>
	)
}

export default function ServiciosPage(): React.JSX.Element {
	return (
		<>
			<PageMeta {...PAGE_SEO.servicios} path="/servicios" />
			<div className="mx-auto max-w-6xl px-4 py-12">
				<div className="mb-8">
					<h1 className="text-3xl font-bold">Servicios</h1>
				</div>
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{SERVICE_SLUGS.map(slug => {
						const serviceId = getServiceIdBySlug(slug)
						if (!serviceId) return null
						return <ServiceCard key={slug} slug={slug} service={SERVICES[serviceId]} />
					})}
				</div>
			</div>
		</>
	)
}
